import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

export const Player = ({ showProgress, url }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleProgress = () => {
    const duration = videoRef.current.duration;
    const currentTime = videoRef.current.currentTime;
    const progress = (currentTime / duration) * 100;
    setProgress(progress);
  };
  return (
    <div>
      <video
        onTimeUpdate={handleProgress}
        ref={videoRef}
        width='100%'
        height='100%'
        controls
        autoPlay
        muted
        loop
      >
        <source src={url} type='video/mp4' />
      </video>
      {showProgress && (
        <div>
          <button onClick={togglePlay}>{isPlaying ? 'Pause' : 'Play'}</button>
          <progress value={progress} max='100' />
        </div>
      )}
    </div>
  );
};

Player.propTypes = {
  url: PropTypes.string.isRequired,
  showProgress: PropTypes.bool,
};
